import React from 'react'

import { useFieldArray, useFormContext } from 'react-hook-form'

// Binds a field-array component to an RHF useFieldArray, shimming the subset of redux-form's FieldArray API consumers use (length/push/remove/insert/map/forEach).
export default (DecoratedComponent: React.ComponentType<any>) => {
  const FormArray = (props: any) => {
    const { control } = useFormContext()
    const { name } = props
    const { fields, append, remove, insert } = useFieldArray({ control, name })

    // redux-form's fields.map yields the member field name; consumers use only the index, so pass `${name}[${index}]` for parity.
    const fieldsApi = {
      length: fields.length,
      push: (value: any) => append(value),
      remove: (index: number) => remove(index),
      insert: (index: number, value: any) => insert(index, value),
      map: (fn: (memberName: string, index: number) => any) =>
        fields.map((_field, index) => fn(`${name}[${index}]`, index)),
      forEach: (fn: (memberName: string, index: number) => any) =>
        fields.forEach((_field, index) => fn(`${name}[${index}]`, index)),
    }

    return <DecoratedComponent {...props} field={{ fields: fieldsApi }} />
  }

  return FormArray
}
